import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html'
})
export class SvgComponent implements OnInit {

  @Input() color = '#414042';
  @Input() size = 24;
  @Input() strokeWidth = 1.25;
  @Input() icon: string;

  constructor() {
  }

  ngOnInit() {
  }

}
